import { IKnmSupervisionType } from 'APIPackage/CatalogsModule/interfaces/IKnmSupervisionType';

import { IKnmSupervisionTypeSelectOption } from '../interfaces/IKnmSupervisionTypeSelectOption';

export const createKnmSupervisionTypeSelectOption = (
  knmSupervisionType: IKnmSupervisionType,
): IKnmSupervisionTypeSelectOption => ({
  ...knmSupervisionType,
  label: knmSupervisionType.name,
  value: knmSupervisionType.code,
});

export const createKnmSupervisionTypeExtendedSelectOption = (
  knmSupervisionType: IKnmSupervisionType,
): IKnmSupervisionTypeSelectOption => ({
  ...knmSupervisionType,
  label: `${knmSupervisionType.digitCode || ''} ${
    knmSupervisionType.federalLaw?.name ? `${knmSupervisionType.federalLaw?.name} ` : ''
  } - ${knmSupervisionType.name}`,
  value: knmSupervisionType.code,
});
